import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class BetweenPagesService {

  private messageSource = new BehaviorSubject<string>(this.router.url);
  currentMessage = this.messageSource.asObservable();

  constructor(private router: Router) { }

  onChangeModule(conteudo: string){
    this.messageSource.next(conteudo)
    this.router.navigate([conteudo]);
  }

}
